import React, { useState } from 'react'
import { IoMdMail } from "react-icons/io";
import { FaBuffer } from "react-icons/fa";
import { CiCircleInfo } from "react-icons/ci";
import Header from '../../components/header/Header';
import { FaLocationDot } from "react-icons/fa6";
import Footer from "../../components/footer/Footer";
import ResourceBox from '../services/component/ResourceBox';
import { IoIosCall } from "react-icons/io";
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';


const initialState = {
  name: '',
  email: '',
  content: '',
  nameEmpty: '',
  emailEmpty: '',
  contentEmpty: ''
}

const Contact = () => {

  const [cState, updateCState] = useState(initialState);
  const { name, email, content, nameEmpty, emailEmpty, contentEmpty } = cState

  const handleInputChange = (e) => {
    const { name, value } = e.target
    updateCState({
      ...cState, [name]: value
    })
  }
  console.log("cState", cState);

  const handleLoginValidation = () => {
    let nameEmpty = ''
    let emailEmpty = ''
    let contentEmpty = ''
    let formIsValid = true;

    if (!name.trim()) {
      nameEmpty = "Please enter name";
      formIsValid = false;
    }

    if (!email.trim()) {
      emailEmpty = "Please enter email id";
      formIsValid = false;
    } else {
      var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (email.match(validRegex)) {
      } else {
        emailEmpty = "Please enter valid email id";
        formIsValid = false;
      }
    }

    if (!content.trim()) {
      contentEmpty = "Please enter message";
      formIsValid = false;
    }

    updateCState({
      ...cState,
      nameEmpty, emailEmpty, contentEmpty
    })
    return formIsValid
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    let formIsValid = handleLoginValidation();



    // Data to be sent to the server
    const userData = {
      name: name,
      email,
      message: content,
    };
    if (formIsValid) {
      try {
        // http://15.206.16.230:4100/api/v1/static/sendEmail

        const response = await fetch('https://pgdekho.com:4500/api/v1/user/sendContactEmail', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer YOUR_API_KEY', // Optional: Include auth headers if needed
          },
          body: JSON.stringify(userData), // Convert data to JSON string
        });

        //   const response = await fetch('http://15.206.16.230:4100/api/v1/static/sendContactEmail', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     // 'Authorization': 'Bearer YOUR_API_KEY', // Optional: Include auth headers if needed
        //   },
        //   body: JSON.stringify(userData), // Convert data to JSON string
        // });
        console.log('response', response)
        if (response?.status === 200) {
          alert("form submitted successfully");
          updateCState(initialState)
        }
      } catch (error) {
        console.error('Error:', error.message);
      }
    }
  }

  //  const response = await fetch('http://15.206.16.230:4100/api/v1/static/sendContactEmail',{
  //   method:'',
  //   headers: {
  //     'Content-Type':'application/json',
  //   },
  //   body:JSON.stringify(payload),
  //  });
  //  const data = await response.json();
  //  console.log(data);

  const location = useLocation();
  console.log("locationContact", location?.pathname);

  return (
    <>
      <Helmet>
        <title>Contact iLine.ai Logistics | Get in Touch with Delhi's Leading Logistics app</title>
        <meta name="description" content="Need logistics support? Contact iLine Logistics app for reliable delivery and logistics solutions. Reach out to our team for inquiries, support, or partnership opportunities in Delhi NCR." />
        <link rel="canonical" href={`https://iline.ai${location.pathname}`} />
      </Helmet>
      <Header />
      <section className="ContactUs">
        <div className="container">

          <div className="wwaLeft">
            <h2>Contact Us | iLine.ai</h2>
          </div>
          <div className="wwaRight">
            <p>
              We’re here to help you drive sustainable logistics and smarter solutions for your business. Have questions, need assistance, or want to explore opportunities with us? Let’s connect!
            </p>
          </div>

        </div>
      </section>
      {/* <figure>
        <img
          className="ocean-freight-banner-image"
          src={require("../../assets/images/services/service-banner.webp")}
        />
      </figure> */}

      <section className='NewContactUs'>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className='GetInTouch'>
                <h6>Ready to join us?</h6>
                <h2>We Take care about <br /> transportation for your <br /> business
                </h2>
                <p>At I-line we don’t just deliver packages at lower costs —we deliver a cleaner, greener future.  Start your journey with I-Line today: Wallet-Friendly. Eco-Friendly. Future-Ready.
                </p>
              </div>
              <div className="AddressBox">
                <h3>Head Office</h3>
                <p><FaLocationDot />D-9, Vyapar Marg, Block D, <br /> Sector 3 Noida, Uttar Pradesh, Noida,<br /> Delhi 201301 </p>
                <p><IoIosCall /><a href="tel:+919220536259">+91 9220536259</a></p>
                <p><IoMdMail /><a href="mailto:Info@Iline.ai">Info@Iline.ai</a></p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="SendUsMessage">
                <h3>Send Us a Message</h3>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input type="text" className='form-control' placeholder='Your Name' name='name' value={name} onChange={handleInputChange} />
                    {nameEmpty && nameEmpty.length > 0 ? <p class="text-danger">{nameEmpty}</p> : ''}
                  </div>
                  <div className="form-group">
                    <input type="text" className='form-control' placeholder='Your email' name='email' value={email} onChange={handleInputChange} />
                    {emailEmpty && emailEmpty.length > 0 ? <p class="text-danger">{emailEmpty}</p> : ''}
                  </div>
                  <div className="form-group">
                    <textarea rows={6} className='form-control' placeholder='Your text' name='content' value={content} onChange={handleInputChange}></textarea>
                    {contentEmpty && contentEmpty.length > 0 ? <p class="text-danger">{contentEmpty}</p> : ''}
                  </div>
                  <button className='BrandBtn'>Submit</button>
                </form>
              </div>
            </div>
          </div>

        </div>

      </section>

      {/* <section className='ResourcesArea'>
        <div className='section-title'>
          <h6>resourses</h6>
          <h2>Services Included in Every Plan</h2>
          <h6>Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo <br /> minus id quod maxime placeat facere possimus, omnis voluptas assumenda est.</h6>
        </div>

        <div className="container">
          <div className="row">
            <ResourceBox />
          </div>
        </div>
      </section> */}
      {/* <section className='ClientsArea'>
        <div className="container">
          <aside>
            <a href="javascript:void(0);"><img src={require('../../assets/images/contact/code.png')} /></a>
            <a href="javascript:void(0);"><img src={require('../../assets/images/contact/wave.png')} /></a>
            <a href="javascript:void(0);"><img src={require('../../assets/images/contact/star.png')} /></a>
            <a href="javascript:void(0);"><img src={require('../../assets/images/contact/iconic.png')} /></a>
            <a href="javascript:void(0);"><img src={require('../../assets/images/contact/alisa.png')} /></a>
            <a href="javascript:void(0);"><img src={require('../../assets/images/contact/design.png')} /></a>
          </aside>
        </div>
      </section> */}

      <Footer />
    </>
  )
}

export default Contact
